export default __webpack_public_path__ + "static/media/(USDC:DAI).14057f56.png";